import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@shared/ui/breadcrumb";
import { Link, useMatches } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";

const Breadcrumbs = () => {
	const matches = useMatches();

	return (
		<Breadcrumb>
			<BreadcrumbList>
				{matches
					.filter((match) => match.staticData?.breadcrumbId)
					.map((match, index, array) => {
						const isLast = index === array.length - 1;

						const label = match.loaderData?.productName || match.staticData?.breadcrumbTitle;

						const breadcrumbId = match.staticData?.breadcrumbId;

						if (isLast)
							return (
								<BreadcrumbItem key={match.id}>
									<BreadcrumbPage>
										<FormattedMessage defaultMessage={label} id={breadcrumbId} />
									</BreadcrumbPage>
								</BreadcrumbItem>
							);
						return (
							<BreadcrumbItem key={match.id}>
								<Link from={match.fullPath} to={match.fullPath}>
									<BreadcrumbLink>
										<FormattedMessage defaultMessage={label} id={breadcrumbId} />
									</BreadcrumbLink>
								</Link>
								<BreadcrumbSeparator />
							</BreadcrumbItem>
						);
					})}
			</BreadcrumbList>
		</Breadcrumb>
	);
};

export default Breadcrumbs;
